<style scoped>
.block {
  display: block;
}

.inline-block {
  display: inline-block;
}
.showme {
  display: inline;
}

.collapsible-header i {
  margin-right: 0;
}
.address-panel {
  padding: 5px;
  /* border-top: 1px solid gray; */
  border-bottom: 1px solid #ddd;
}
.address-panel .address-details label {
  font-size: 16px;
  cursor: pointer;
}
.address-panel .address-details.active label {
  color: black;
}
.address-panel .address-details {
  cursor: pointer;
  display: flex;
  justify-content: space-between;
}
.add-new-cont {
  display: flex;
  justify-content: space-between;
  align-items: center;
  cursor: pointer;
}
div.switch {
  display: flex;
  justify-content: space-between;
  margin: 0.3rem 0;
}
div.switch label {
  font-size: 16px !important;
}
.default-address {
  border-radius: 31px;
  border: solid green 1px;
  padding: 1px 14px;
  font-size: 10px !important;
  color: green !important;
}
</style>

<template lang="pug">
div
  p.title.small Delivery details
  p.subtitle.light You will be contacted through
    .input-field
      i.material-icons.prefix phone
      input#contactNumber(
        type='text',
        placeholder='Your contact number',
        v-model='contactNumber',
        @input='isNumber($event)'
      )

  div(v-if='user')
    .title.small Where should we deliver?
    v-row(v-if='addresses.length')
      v-col.input-field.mrgn0(cols='12', sm='12')
        .active Choose an existing delivery address

        .address-panel(v-for='address in addresses')
          .address-details(
            @click='setAddress(address.id)',
            v-bind:class='{ active: address.name === addressSELECTED }'
          )
            div
              label {{ address.name }}
            i.material-icons.red-text(v-if='address.name === addressSELECTED') done
      v-col.input-field.mrgn0(cols='12', sm='12')
        .active Choose an existing billing address

        .address-panel(v-for='address in addresses')
          .address-details(
            @click='setAddressBilling(address.id)',
            v-bind:class='{ active: address.name === addressBillingSELECTED }'
          )
            div
              label {{ address.name }}
            i.material-icons.red-text(
              v-if='address.name === addressBillingSELECTED'
            ) done

  ul.collapsible(data-collapsible='accordion')
    li
      .collapsible-header.active
        .btn-compound.bordered.width100(style='display: contents !important')
          a.btn-compound-item.waves-effect
            i.material-icons place
          a.btn-compound-item.waves-effect Add new address
      .collapsible-body
        div(v-if='user')
          //- .title.small Where should we deliver?
          //- v-row(v-if='addresses.length')
          //-   v-col.input-field.mrgn0(cols='12', sm='12')
          //-     .active Choose an existing delivery address

          //-     .address-panel(v-for='address in addresses')
          //-       .address-details(
          //-         @click='setAddress(address.id)',
          //-         v-bind:class='{ active: address.name === addressSELECTED }'
          //-       )
          //-         div
          //-           label {{ address.name }}
          //-         i.material-icons.red-text(
          //-           v-if='address.name === addressSELECTED'
          //-         ) done

          //- v-row(v-if='addresses.length')
          //-   v-col.input-field.mrgn0(cols='12', sm='12')
          //-     .active Choose an existing billing address

          //-     .address-panel(v-for='address in addresses')
          //-       .address-details(
          //-         @click='setAddressBilling(address.id)',
          //-         v-bind:class='{ active: address.name === addressBillingSELECTED }'
          //-       )
          //-         div
          //-           label {{ address.name }}
          //-         i.material-icons.red-text(
          //-           v-if='address.name === addressBillingSELECTED'
          //-         ) done

          v-row
            v-col.add-new-cont(cols='12', xs='12')
              p.title.light(@click='addnewshow') Add new address
              i.material-icons.red-text(@click='addnewshow') add
            v-col(cols='12', xs='12')
              v-overlay(:value='loading')
                v-progress-circular(
                  :size='70',
                  :width='7',
                  color='#b03236',
                  indeterminate
                )
              v-form.add-address(v-if='collapseAddnew')
                v-row
                  v-col(cols='12', sm='12')
                    v-text-field#address1(
                      v-model='address.address1',
                      label='Address 1*',
                      :rules='rules'
                    )
                  v-col(cols='12', sm='12')
                    v-text-field#address2(
                      label='Address 2 (optional)',
                      v-model='address.address2'
                    )
                  v-col(cols='12', sm='12')
                    v-text-field#city(
                      label='City/Municipality*',
                      v-model='address.city'
                    )
                  v-col(cols='12', sm='12')
                    v-text-field#state(
                      label='Province*',
                      v-model='address.state'
                    )
                  v-col(cols='12', md='6')
                    v-text-field#zip(
                      label='Postcode*',
                      v-model='address.postcode'
                    )
                  v-col(cols='12', md='6')
                    v-text-field#country(
                      label='Country*',
                      v-model='address.country'
                    )
                v-row
                  v-col(cols='12')
                    .switch
                      label Make default shipping address
                      label
                        input#status(
                          v-model='defaultShipStatus',
                          type='checkbox'
                        )
                        span.lever
                  v-col(cols='12')
                    .switch
                      label Make default billing address
                      label
                        input#statusShip(
                          v-model='defaultBillingStatus',
                          type='checkbox',
                          :value='"B"'
                        )
                        span.lever
                v-row(v-if='!defaultBillingStatus')
                  v-col(cols='12', xs='12')
                    p.title.light Add new billing address
                  v-col(cols='12', sm='12')
                    v-text-field#address1(
                      v-model='addressBilling.address1',
                      label='Address 1*'
                    )
                  v-col(cols='12', sm='12')
                    v-text-field#address2(
                      label='Address 2 (optional)',
                      v-model='addressBilling.address2'
                    )
                  v-col(cols='12', sm='12')
                    v-text-field#city(
                      label='City/Municipality*',
                      v-model='addressBilling.city'
                    )
                  v-col(cols='12', sm='12')
                    v-text-field#state(
                      label='Province*',
                      v-model='addressBilling.state'
                    )
                  v-col(cols='12', md='6')
                    v-text-field#zip(
                      label='Postcode*',
                      v-model='addressBilling.postcode'
                    )
                  v-col(cols='12', md='6')
                    v-text-field#country(
                      label='Country*',
                      v-model='addressBilling.country'
                    )
                //- v-overlay(:value='true', :absolute='true')
                .row
                  .col.s12.mt-5.right-align
                    v-btn.white-text(
                      @click='addAddress',
                      :disabled='isValid()',
                      color='#b03236'
                    ) Save
        div(v-else)
          p.title.small Almost there!
          p You have to be logged in to set your address
          router-link.indigo-text(
            :to='{ path: "login", query: { redirectUrl: $route.path } }'
          ) Log-in or register
</template>
<script>
import AppAddressSetup from '@/components/app-address-setup'
import debounce from 'debounce'

export default {
  // props: ["onAddressSet"],
  data() {
    return {
      showModal: false,
      modalContent: AppAddressSetup,
      onContactNumberUpdated: debounce(this.updateContactNumber, 1000),
      cityAutocomplete: null,
      defaultBillingStatus: true,
      defaultShipStatus: true,
      defaultBillingID: null,
      defaultShipID: null,
      address: {
        line1: null,
        zipCode: null,
        location: null,
        address1: null,
        address2: null,
        city: null,
        state: null,
        country: null,
        postcode: null,
        addresstype: null,
      },
      addressBilling: {
        line1: null,
        zipCode: null,
        location: null,
        address1: null,
        address2: null,
        city: null,
        state: null,
        country: null,
        postcode: null,
        addresstype: null,
      },
      mounted: false,
      citiesLoaded: false,
      collapseAddnew: false,
      loading: false,
    }
  },
  mounted() {
    this.$M.Collapsible.init(document.querySelectorAll('.collapsible'))
  },
  created() {
    this.initializeAddresses()
  },
  computed: {
    user() {
      return this.$store.state.auth.user
    },
    currentAddress() {
      return !this.$store.state.cart.address
        ? null
        : this.$store.state.cart.address.id
    },
    addresses() {
      const address = this.$store.getters['customer/friendlyAddresses'] || []
      let list = address.filter(
        (elem, index, self) =>
          self.findIndex((address) => {
            return address.name === elem.name
          }) === index
      )
      return list
      // return this.$store.getters["customer/friendlyAddresses"] || [];
    },
    location() {
      return this.$store.state.cart.location
    },
    '$store.state.customer.addresses'() {
      this.initializeAddresses()
    },
    // original
    addressSELECTED() {
      return this.$store.state.cart.address
        ? this.$store.state.cart.address.name
        : 'Set delivery address'
    },
    addressBillingSELECTED() {
      return this.$store.state.cart.billing
        ? this.$store.state.cart.billing.name
        : 'Set delivery address'
    },
    contactNumber: {
      get() {
        this.$store.dispatch(
          'cart/setContactNumber',
          this.$store.state.user.phoneNumber
        )
        return this.$store.state.user.phoneNumber
      },
      set(contactNumber) {
        if (/^[0-9]*$/.test(contactNumber)) {
          this.onContactNumberUpdated(contactNumber)
          this.$store.dispatch('cart/setContactNumber', contactNumber)
        }
      },
    },
    rules() {
      const rules = []

      rules.push((value) => !!value || 'Required.')

      // if (this.max) {
      //   const rule = (v) =>
      //     (v || '').length <= this.max ||
      //     `A maximum of ${this.max} characters is allowed`

      //   rules.push(rule)
      // }

      // if (!this.allowSpaces) {
      //   const rule = (v) =>
      //     (v || '').indexOf(' ') < 0 || 'No spaces are allowed'

      //   rules.push(rule)
      // }

      // if (this.match) {
      //   const rule = (v) => (!!v && v) === this.match || 'Values do not match'

      //   rules.push(rule)
      // }

      return rules
    },
  },
  watch: {
    '$store.state.cart.address'() {
      this.showModal = false
    },
  },
  methods: {
    updateContactNumber(contactNumber) {
      this.$store.dispatch('cart/setContactNumber', contactNumber)
    },
    openModal() {
      const modalParams = {
        content: AppAddressSetup,
        style: { padding: 'medium' },
        bind: { onAddressSet: this.closeModal },
      }

      this.$store.dispatch('modal/open', modalParams)
    },
    closeModal() {
      this.$store.dispatch('modal/close')
    },
    addnewshow() {
      this.collapseAddnew = !this.collapseAddnew
    },
    isDefaultAdress(add) {
      return this.defaultShipID === JSON.stringify(add.id)
    },
    // new
    initializeAddresses() {
      this.$nextTick(() => {
        this.$M.FormSelect.init(this.$refs.addressSelect)
      })
    },
    async addAddress() {
      this.loading = true
      await this.$store
        .dispatch('customer/addAddress', {
          ...this.address,
          addresstype: 'S',
        })
        .then((address) => {
          this.$snackbar.success('Address added')
          this.addnewshow()
          this.setAddress(address.id)
          if (this.defaultBillingStatus) {
            this.addBillingAddress(this.address)
          } else {
            this.addBillingAddress(this.addressBilling)
          }
          this.address = {
            line1: null,
            zipCode: null,
            location: null,
            address1: null,
            address2: null,
            city: null,
            state: null,
            country: null,
            postcode: null,
            addresstype: null,
          }
          this.loading = false
        })
    },
    addBillingAddress(address) {
      this.$store
        .dispatch('customer/addAddress', {
          ...address,
          addresstype: 'B',
        })
        .then((address) => {
          this.addressBilling = {
            line1: null,
            zipCode: null,
            location: null,
            address1: null,
            address2: null,
            city: null,
            state: null,
            country: null,
            postcode: null,
            addresstype: null,
          }
        })
    },
    isValid() {
      // if (!this.addressBilling.address1 || !this.addressBilling.address2 ||
      // !this.addressBilling.city || !this.addressBilling.state ||
      //  !this.addressBilling.country ||  !this.addressBilling.postcode ) {
      if (
        !this.address.address1 ||
        !this.address.city ||
        !this.address.state ||
        !this.address.country ||
        !this.address.postcode
      ) {
        return true
      } else {
        return false
      }
    },
    setAddress(e) {
      const address = this.$store.getters['customer/getFriendlyAddressById'](
        // e.target.value
        e
      )

      this.$store.dispatch('cart/setAddress', address)
      if (typeof this.onAddressSet === 'function') {
        this.onAddressSet(address)
      }
    },
    setAddressBilling(e) {
      const address = this.$store.getters['customer/getFriendlyAddressById'](
        // e.target.value
        e
      )

      this.$store.dispatch('cart/setAddressBilling', address)
      if (typeof this.onAddressSet === 'function') {
        this.onAddressSet(address)
      }
    },
    isNumber(event) {
      event.target.value = event.target.value.replace(/[^0-9]/g, '')
    },

    isNumberZip(event) {
      this.address.zipCode = event.target.value.replace(/[^0-9]/g, '')
    },
  },
}
</script>



// WEBPACK FOOTER //
// src/components/page-cart-address.vue